<template>
  <div>
    <HeaderComp></HeaderComp>

    <div class="otsing">
      <!-- Left: Search Form -->
      <div class="form-container">
        <h1>Otsing</h1>

        <form @submit.prevent="createPost">
          <!-- Tootja ja mudel section -->
          <div class="section-header">Tootja ja mudel</div>
          <table>
            <tbody>
              <!-- Tootja Dropdown -->
              <tr>
                <td><label for="tootja">Tootja</label></td>
                <td>
                  <div class="dropdown">
                    <button
                      @click="toggleDropdown('tootja')"
                      class="dropdown-btn"
                    >
                      {{ tootja || "Vali tootja" }}
                    </button>
                    <ul v-show="isOpen.tootja" class="dropdown-menu">
                      <li
                        v-for="option in tootjaOptions"
                        :key="option"
                        @click="selectItem('tootja', option)"
                      >
                        {{ option }}
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>

              <tr>
                <td><label for="mudel">Mudel</label></td>
                <td>
                  <input type="text" v-model="mudel" class="text-input" />
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Mõõdud section -->
          <div class="section-header">Mõõdud</div>
          <table>
            <tbody>
              <!-- Mõõt Dropdown -->
              <tr>
                <td><label for="mõõt">Mõõt</label></td>
                <td>
                  <div class="dropdown">
                    <button
                      @click="toggleDropdown('mõõt')"
                      class="dropdown-btn"
                    >
                      {{ mõõt || "Vali mõõt" }}
                    </button>
                    <ul v-show="isOpen.mõõt" class="dropdown-menu">
                      <li
                        v-for="option in mõõtOptions"
                        :key="option"
                        @click="selectItem('mõõt', option)"
                      >
                        {{ option }}
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>

              <!-- Diameeter Dropdown -->
              <tr>
                <td><label for="diameeter">Diameeter</label></td>
                <td>
                  <div class="dropdown">
                    <button
                      @click="toggleDropdown('diameeter')"
                      class="dropdown-btn"
                    >
                      {{ diameeter || "Vali diameeter" }}
                    </button>
                    <ul v-show="isOpen.diameeter" class="dropdown-menu">
                      <li
                        v-for="option in diameeterOptions"
                        :key="option"
                        @click="selectItem('diameeter', option)"
                      >
                        {{ option }}
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Rehvitüüp section -->
          <div class="section-header">Rehvi tüüp</div>
          <div class="checkbox-container">
            <label><input type="checkbox" v-model="suverehv" /> Suverehv</label>
            <label
              ><input type="checkbox" v-model="talverehv" /> Talverehv</label
            >
            <label
              ><input type="checkbox" v-model="naastrehv" /> Naastrehv</label
            >
            <label><input type="checkbox" v-model="offroad" /> Offroad</label>
            <label><input type="checkbox" v-model="ringrada" /> Ringrada</label>
            <label
              ><input type="checkbox" v-model="taastatud" /> Taastatud</label
            >
          </div>

          <!-- Muud näitajad section -->
          <div class="section-header">Muud näitajad</div>
          <table>
            <tbody>
              <tr>
                <td><label for="lisi">Li/Si</label></td>
                <td>
                  <input
                    type="text"
                    v-model="lisi"
                    class="text-input"
                    placeholder="Kõik"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Üldised andmed section -->
          <div class="section-header">Üldised andmed</div>
          <div class="checkbox-container">
            <label><input type="checkbox" v-model="uus" /> Uus</label>
            <label
              ><input type="checkbox" v-model="kasutatud" /> Kasutatud</label
            >
          </div>

          <!-- Search Button -->
          <button type="submit" class="search-button">Otsi</button>
        </form>
      </div>

      <!-- Right: Dynamic Table -->
      <div class="table-container">
        <h2>Otsingu tulemused</h2>
        <table v-if="items.length" class="results-table">
          <thead>
            <tr>
              <th>Tootja ja mudel</th>
              <th>Tüüp</th>
              <th>Mõõt</th>
              <th>Diam.</th>
              <th>Li/Si</th>
              <th>Tk</th>
              <th>Hind</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <td>{{ item.tootjaMudel }}</td>
              <td>{{ item.tüüp }}</td>
              <td>{{ item.mõõt }}</td>
              <td>{{ item.diameeter }}</td>
              <td>{{ item.liSi }}</td>
              <td>{{ item.tk }}</td>
              <td>{{ item.hind }}€</td>
            </tr>
          </tbody>
        </table>
        <p v-else>Otsingu tulemusi ei leitud.</p>
      </div>
    </div>
    <FooterComp></FooterComp>
  </div>
</template>

<script>
import HeaderComp from "@/components/HeaderComp.vue";
import FooterComp from "@/components/FooterComp.vue";

export default {
  name: "SearchForm",
  components: {
    HeaderComp,
    FooterComp,
  },
  data() {
    return {
      tootja: "",
      mudel: "",
      mõõt: "",
      diameeter: "",
      isOpen: { tootja: false, mõõt: false, diameeter: false },
      tootjaOptions: ["BMW", "Audi", "Toyota", "Mercedes", "Volkswagen"],
      mõõtOptions: ["185/65 R15", "195/65 R16", "205/55 R17", "225/45 R18"],
      diameeterOptions: ["R15", "R16", "R17", "R18"],
      items: [
        {
          tootjaMudel: "BMW X5",
          tüüp: "Suverehv",
          mõõt: "235/40 R19",
          diameeter: "R19",
          liSi: "98W",
          tk: 4,
          hind: 120,
        },
        {
          tootjaMudel: "Audi A6",
          tüüp: "Talverehv",
          mõõt: "205/55 R17",
          diameeter: "R17",
          liSi: "91H",
          tk: 2,
          hind: 90,
        },
        {
          tootjaMudel: "Toyota Corolla",
          tüüp: "Naastrehv",
          mõõt: "195/65 R16",
          diameeter: "R16",
          liSi: "88T",
          tk: 2,
          hind: 85,
        },
      ],
    };
  },
  methods: {
    toggleDropdown(type) {
      this.isOpen[type] = !this.isOpen[type];
      for (const key in this.isOpen) {
        if (key !== type) this.isOpen[key] = false;
      }
    },
    selectItem(type, value) {
      this[type] = value;
      this.isOpen[type] = false;
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Alata&display=swap");

* {
  font-family: "Alata", sans-serif;
}

/* Layout */
.otsing {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 44px 20px 66px 20px;
  min-height: 80vh;
  background:
    linear-gradient(180deg, #151217 0, #151217 96px, #fff7fb 96px, #ffffff 100%);
}

/* Search Form */
.form-container {
  padding: 22px;
  border: 1px solid #f0bdd3;
  background: #ffffff;
  width: 100%;
  max-width: 300px;
  text-align: left;
  border-radius: 8px;
  box-shadow: 0 26px 64px rgba(42, 22, 34, 0.13);
}

/* Section Headers */
.section-header {
  background: #211820;
  color: white;
  text-align: left;
  font-weight: bold;
  padding: 10px;
  margin-top: 10px;
  border-radius: 7px;
  border-left: 5px solid #e22289;
}

/* Text Inputs */
.text-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ead4df;
  border-radius: 7px;
  box-sizing: border-box;
}

/* Two Inputs Side by Side */
.double-input {
  display: flex;
  align-items: center;
  gap: 5px;
}

.small-input {
  width: 40%;
}

/* Checkboxes */
.checkbox-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px 0;
}

.checkbox-container label {
  display: flex;
  align-items: center;
  gap: 8px;
}

input[type="checkbox"] {
  transform: scale(1.2);
}

/* Search Button */
.search-button {
  width: 100%;
  padding: 10px;
  background: #e22289;
  color: white;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  font-weight: bold;
  margin-top: 10px;
  transition: background 0.3s;
}

.search-button:hover {
  background: #c01672;
}

/* Results Table */
.table-container {
  flex-grow: 1;
  padding: 20px;
  border: 1px solid #f0bdd3;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 26px 64px rgba(42, 22, 34, 0.13);
  overflow-x: auto;
  max-width: 860px;
}

.results-table {
  width: 100%;
  border-collapse: collapse;
}

.results-table th,
.results-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}

.results-table th {
  background: #211820;
  color: #ffffff;
  border-color: #211820;
}

.results-table tr:nth-child(even) {
  background: #fff8fc;
}

/* Improved Dropdown Styling */
.dropdown {
  position: relative;
  width: 100%;
}

.dropdown-btn {
  width: 100%;
  padding: 10px;
  border: 1px solid #ead4df;
  background: white;
  color: #211820;
  text-align: left;
  cursor: pointer;
  border-radius: 7px;
  position: relative;
  transition: background 0.3s;
  box-sizing: border-box;
}

.dropdown-btn:hover {
  background: #fff0f7;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #ead4df;
  border-radius: 7px;
  box-shadow: 0 16px 34px rgba(42, 22, 34, 0.14);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0;
}

.dropdown-menu li {
  padding: 10px;
  cursor: pointer;
  transition: background 0.3s;
}

.dropdown-menu li:hover {
  background: #e22289;
  color: white;
}

@media (max-width: 768px) {
  .otsing {
    flex-direction: column;
    padding: 20px 10px 40px 10px;
    background:
      linear-gradient(180deg, #151217 0, #151217 54px, #fff7fb 54px, #ffffff 100%);
  }

  .form-container,
  .table-container {
    width: 100%;
    max-width: none;
    box-sizing: border-box;
  }
}
</style>
